import PropTypes from 'prop-types';
import React from 'react';
import styled from 'react-emotion';

import ErrorMessage from '../../../../components/Messages/ErrorMessage';
import Style from '../../../../styles/common';
import SubmitButton from '../../../../components/Buttons/SubmitButton';

const Container = styled('div')`
  margin-top: ${Style.SPACING.XXXL};
`;

class CreateEventFormFooter extends React.Component {
  render() {
    return (
      <Container>
        <SubmitButton
          disabled={this.props.isSubmitting}
          loading={this.props.isSubmitting}
        >
          Create event
        </SubmitButton>
        {this.errorMessage}
      </Container>
    );
  }

  get errorMessage() {
    if (this.props.hasFailed || this.props.submitFailed) {
      return (
        <ErrorMessage shouldAnimate={true}>
          Failed to create event
        </ErrorMessage>
      );
    }
    return null;
  }
}

CreateEventFormFooter.propTypes = {
  hasFailed: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  isSuccessful: PropTypes.bool,
};

CreateEventFormFooter.defaultProps = {
  hasFailed: false,
  isSubmitting: false,
  isSuccessful: false,
};

export default CreateEventFormFooter;



// WEBPACK FOOTER //
// ./src/views/CreateEvent/CreateEventForm/CreateEventFormFooter/CreateEventFormFooter.js